import React, { useContext, useState, useEffect } from "react";
import Col from "../../../UIcomponent/Column";
import LocalContext from "../../../Context/LocalContetxt";
import "./ProfileCalendar.scss";
import { Loader } from "../../../UIcomponent/Loader";
import ProfileReq from "../../../Utility/Requester/ProfileReq";
import DateTime from "../../../Utility/Method/DateTime";
import moment from "moment-jalaali";
import { TodayObj } from "../../../Utility/TodayObj";
import Schedule from "../../CalendarSchedule/Schedule";
import { Notify } from "../../../UIcomponent/NotificationManager";
const ProfileCalendar = (props) => {
  const lang = useContext(LocalContext).lang;
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(false);

  const GetAvailabilty = (FromTo) => {
    let params = {
      timeZone: DateTime.timeZone(),
      dateTimeFrom: FromTo.dateTimeFrom,
      dateTimeTo: FromTo.dateTimeTo,
    };
    setLoading(true);
    ProfileReq.ListTeacherAvai(params)
      .then((res) => {
        let Result = [];
        if (res.data !== null) {
          Result = res.data.map((each) => {
            return {
              ID: each.ID,
              date_time_from: each.from,
              date_time_to: each.to,
              Status: each.Status,
              initialStatus: each.Status,
            };
          });
        }
        setData([...Result]);
        setLoading(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    let FromTo = {
      dateTimeFrom: moment(
        new Date(TodayObj(0).Year, TodayObj(0).Month, TodayObj(0).Day, 0, 0, 0)
      ).toISOString(),
      dateTimeTo: moment(
        new Date(
          TodayObj(0).Year,
          TodayObj(0).Month,
          TodayObj(0).Day + 7,
          0,
          0,
          0
        )
      ).toISOString(),
    };
    GetAvailabilty(FromTo);
  }, []);

  const onNextWeek = (FromTo) => {
    GetAvailabilty(FromTo);
  };
  const onPreviousWeek = (FromTo) => {
    GetAvailabilty(FromTo);
  };
  const onSubmit = (data, FromTo) => {
    ProfileReq.TeacherAvaiUpdate(data)
      .then((res) => {
        Notify("success", "تغییرات با موفقیت انجام شد", 2000);
        // GetAvailabilty(FromTo)
        setTimeout(() => {
          setIsSubmiting(false);
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        setIsSubmiting(false);
        Notify("error", err.response.data.message, 2000);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
  };
  return (
    <>
      {/* <Col className="c__NotAvailableOnMobile">
        این صفحه در دسکتاپ قابل استفاده می باشد.
      </Col> */}
      <Col
        className="l__ProfileCalendar"
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        lang={lang}
      >
        <Col
          className="c__ProfileCalendar"
          xl={23}
          lg={23}
          md={23}
          sm={24}
          xs={24}
        >
          <Schedule
            Calendar
            duration={0.5}
            lang={lang}
            row={8}
            size={30}
            Slot={1}
            Data={Data}
            loading={loading}
            Loader={Loader}
            onNextWeek={onNextWeek}
            onPreviousWeek={onPreviousWeek}
            isSubmiting={isSubmiting}
            onSubmit={onSubmit}
          />
        </Col>
      </Col>
    </>
  );
};

export default ProfileCalendar;
